// PERSONA FRAGRANCE INTELLIGENCE — Phase 2 translations (adds Journey, Academy, MyAccount, Scent Pyramid keys)
export const P2 = {
  en: {
    // Public nav
    nav_journey: "The Journey",
    nav_founder: "Master Perfumer",
    nav_my_account: "My Account",
    nav_academy: "IPTECHS Academy",

    // Landing additions
    landing_ecosystem_learn: "LEARN",
    landing_ecosystem_learn_desc: "IPTECHS Academy",
    landing_ecosystem_explore: "EXPLORE",
    landing_ecosystem_explore_desc: "PERSONA AI PERFUMER",
    landing_ecosystem_create: "CREATE",
    landing_ecosystem_create_desc: "PERSONA PERFUMERY TECH",
    heritage_eyebrow: "The heritage behind PERSONA",
    heritage_title: "Founded by a master perfumer.",
    heritage_body:
      "PERSONA FRAGRANCE INTELLIGENCE is founded by Tubagus Wijaya — master perfumer, fragrance technologist, and the person behind more than a decade of personalized fragrance research.",
    heritage_cta: "MEET THE MASTER PERFUMER",
    protected_eyebrow: "Protected Technology",
    protected_title: "Three layers, one protected core.",
    protected_persona: "PERSONA",
    protected_persona_desc: "Registered Trademark",
    protected_software: "PERSONA SOFTWARE",
    protected_software_desc: "Registered Computer Program Copyright",
    protected_core: "PERSONA CORE",
    protected_core_desc: "Proprietary / Confidential Technology Layer",
    twfh_eyebrow: "The Fragrance House",
    twfh_title: "TWFH",
    twfh_subtitle: "Tubagus Wijaya Fragrance House",
    twfh_position: "Fragrance House · Craftsmanship · Formulation · Fragrance Expertise",
    twfh_desc:
      "TWFH represents the fragrance craftsmanship behind the ecosystem — connecting perfumery artistry, formulation expertise and fragrance creation.",

    // Journey (founder) page
    journey_eyebrow: "Master Perfumer",
    journey_name: "Tubagus Wijaya",
    journey_role: "Founder · Master Perfumer · Fragrance Technologist",
    journey_statement:
      "From fragrance craftsmanship to personalized fragrance technology, the journey has always been about making scent more personal, meaningful and intelligent.",
    journey_timeline_title: "The Journey",
    j_2012_title: "The Beginning",
    j_2012_body:
      "Personalized fragrance research begins — the origin of the concept that eventually became PERSONA.",
    j_2015_title: "Creative & Innovation Recognition",
    j_2015_body:
      "Recognition in the creative industry and SME innovation field.",
    j_2016_title: "Entrepreneurship",
    j_2016_body: "Recognition in entrepreneurship through Parfum Gue.",
    j_16_18_title: "Perfumery Education & Professional Development",
    j_16_18_body:
      "Professional perfumery education and development through multiple training experiences.",
    j_2019_title: "Innovation & Recognition",
    j_2019_body:
      "Recognition for product innovation and MURI recognition related to personalized fragrance based on customer personality characteristics.",
    j_2022_title: "Entrepreneurial Development",
    j_2022_body: "6 Besar Talenta Wirausaha Berdaya — Bank Syariah Indonesia.",
    j_2026_title: "From Perfumery Technology to Fragrance Intelligence",
    j_2026_body:
      "The evolution of the fragrance technology vision into PERSONA FRAGRANCE INTELLIGENCE — connecting Human Fragrance Expertise + Fragrance Knowledge + Conversational AI + Proprietary Technology.",
    edu_title: "Perfumery Education & Professional Development",
    recog_title: "Innovation & Recognition",
    legacy_title: "The Technology Legacy",
    legacy_intro:
      "One coherent ecosystem — from craftsmanship, to education, to conversational fragrance intelligence, to proprietary technology.",
    legacy_twfh_role: "Fragrance Craftsmanship",
    legacy_iptechs_role: "Fragrance Education",
    legacy_persona_role: "Personalized Fragrance Technology",
    legacy_core_role: "Proprietary Technology",
    legacy_ai_role: "Conversational Fragrance Intelligence",
    legacy_platform_role: "The connecting ecosystem",

    // Academy
    academy_eyebrow: "LEARN · Indonesia Perfumer Technology School",
    academy_title: "IPTECHS Academy",
    academy_intro:
      "Structured learning journeys designed and curated by the master perfumer. Advance from foundational vocabulary to intelligent fragrance systems.",
    academy_courses: "Courses",
    academy_continue: "Continue Learning",
    academy_start: "Start Course",
    academy_open: "Open",
    academy_locked: "Locked",
    academy_completed: "Completed",
    academy_mark_complete: "Mark as complete",
    academy_next: "Next lesson",
    academy_progress: "Progress",
    academy_lessons: "lessons",
    academy_completed_lessons: "Completed lessons",
    academy_level: "Level",
    academy_duration: "Duration",
    academy_cert_title: "IPTECHS Certified Perfumer",
    academy_cert_body:
      "Learning → Practical Examination → Offline Assessment → Result → Certification. A non-academic professional credential issued by IPTECHS.",
    academy_cert_addon: "Certification is a separate paid add-on. Not automatically issued.",
    academy_membership_note:
      "Membership = PERSONA AI PERFUMER access + IPTECHS Academy access.",

    // My Account
    account_title: "My Account",
    account_sub: "Manage your member profile and access.",
    account_name: "Name",
    account_email: "Email",
    account_language: "Preferred language",
    account_membership: "Membership status",
    account_ai_access: "AI access",
    account_academy_access: "Academy access",
    account_enabled: "Enabled",

    // AI Scent Direction & Save
    ai_direction_title: "AI Scent Direction",
    ai_direction_generate: "Generate AI Scent Direction",
    ai_direction_regenerate: "Regenerate",
    ai_direction_from: "Interpretation from the current consultation",
    ai_pyramid_top: "Top Notes",
    ai_pyramid_heart: "Heart Notes",
    ai_pyramid_base: "Base Notes",
    ai_personality: "Fragrance Personality",
    ai_direction_line: "Olfactory Direction",
    ai_families_rec: "Recommended Families",
    ai_interpretation: "AI Interpretation",
    ai_save_profile: "Save AI Fragrance Profile",
    ai_saved: "AI Fragrance Profile saved",
    ai_not_official:
      "AI-generated fragrance interpretation. Not an official PERSONA CORE result.",
    saved_profiles_title: "Saved AI Fragrance Profiles",
    saved_profiles_empty: "You haven't saved any AI fragrance profile yet.",

    // Subscription empty state
    sub_configuring: "Membership is being configured. Pricing and checkout will appear here soon.",
  },
  id: {
    nav_journey: "Perjalanan",
    nav_founder: "Master Perfumer",
    nav_my_account: "Akun Saya",
    nav_academy: "IPTECHS Academy",

    landing_ecosystem_learn: "LEARN",
    landing_ecosystem_learn_desc: "IPTECHS Academy",
    landing_ecosystem_explore: "EXPLORE",
    landing_ecosystem_explore_desc: "PERSONA AI PERFUMER",
    landing_ecosystem_create: "CREATE",
    landing_ecosystem_create_desc: "PERSONA PERFUMERY TECH",
    heritage_eyebrow: "Warisan di balik PERSONA",
    heritage_title: "Didirikan oleh seorang master perfumer.",
    heritage_body:
      "PERSONA FRAGRANCE INTELLIGENCE didirikan oleh Tubagus Wijaya — master perfumer, fragrance technologist, dan sosok di balik lebih dari satu dekade riset wewangian personal.",
    heritage_cta: "TEMUI MASTER PERFUMER",
    protected_eyebrow: "Teknologi Terlindungi",
    protected_title: "Tiga lapisan, satu inti yang dilindungi.",
    protected_persona: "PERSONA",
    protected_persona_desc: "Merek Terdaftar",
    protected_software: "PERSONA SOFTWARE",
    protected_software_desc: "Hak Cipta Program Komputer Terdaftar",
    protected_core: "PERSONA CORE",
    protected_core_desc: "Lapisan Teknologi Proprietari / Rahasia",
    twfh_eyebrow: "Fragrance House",
    twfh_title: "TWFH",
    twfh_subtitle: "Tubagus Wijaya Fragrance House",
    twfh_position: "Fragrance House · Craftsmanship · Formulasi · Keahlian Wewangian",
    twfh_desc:
      "TWFH merepresentasikan kerajinan wewangian di balik ekosistem — menghubungkan artistri perfumery, keahlian formulasi, dan penciptaan wewangian.",

    journey_eyebrow: "Master Perfumer",
    journey_name: "Tubagus Wijaya",
    journey_role: "Founder · Master Perfumer · Fragrance Technologist",
    journey_statement:
      "Dari kerajinan wewangian hingga teknologi wewangian personal, perjalanan ini selalu tentang membuat aroma menjadi lebih personal, bermakna, dan cerdas.",
    journey_timeline_title: "Perjalanan",
    j_2012_title: "Permulaan",
    j_2012_body:
      "Riset wewangian personal dimulai — asal-usul konsep yang kemudian menjadi PERSONA.",
    j_2015_title: "Kreatif & Inovasi",
    j_2015_body: "Rekognisi di industri kreatif dan bidang inovasi UKM.",
    j_2016_title: "Kewirausahaan",
    j_2016_body: "Rekognisi kewirausahaan melalui Parfum Gue.",
    j_16_18_title: "Pendidikan & Pengembangan Perfumery",
    j_16_18_body:
      "Pendidikan dan pengembangan profesional perfumery melalui beberapa pengalaman pelatihan.",
    j_2019_title: "Inovasi & Rekognisi",
    j_2019_body:
      "Rekognisi inovasi produk dan rekognisi MURI terkait wewangian personal berbasis karakteristik kepribadian pelanggan.",
    j_2022_title: "Pengembangan Kewirausahaan",
    j_2022_body: "6 Besar Talenta Wirausaha Berdaya — Bank Syariah Indonesia.",
    j_2026_title: "Dari Teknologi Wewangian ke Fragrance Intelligence",
    j_2026_body:
      "Evolusi visi teknologi wewangian menjadi PERSONA FRAGRANCE INTELLIGENCE — menghubungkan Keahlian Wewangian Manusia + Pengetahuan Wewangian + AI Percakapan + Teknologi Proprietari.",
    edu_title: "Pendidikan & Pengembangan Profesional Perfumery",
    recog_title: "Inovasi & Rekognisi",
    legacy_title: "Warisan Teknologi",
    legacy_intro:
      "Satu ekosistem yang koheren — dari craftsmanship, pendidikan, hingga intelijen wewangian percakapan, dan teknologi proprietari.",
    legacy_twfh_role: "Fragrance Craftsmanship",
    legacy_iptechs_role: "Fragrance Education",
    legacy_persona_role: "Teknologi Wewangian Personal",
    legacy_core_role: "Teknologi Proprietari",
    legacy_ai_role: "Intelijen Wewangian Percakapan",
    legacy_platform_role: "Ekosistem yang menghubungkan",

    academy_eyebrow: "LEARN · Indonesia Perfumer Technology School",
    academy_title: "IPTECHS Academy",
    academy_intro:
      "Alur belajar terstruktur yang dirancang dan dikurasi oleh master perfumer. Dari kosakata dasar hingga sistem wewangian cerdas.",
    academy_courses: "Kursus",
    academy_continue: "Lanjut Belajar",
    academy_start: "Mulai Kursus",
    academy_open: "Buka",
    academy_locked: "Terkunci",
    academy_completed: "Selesai",
    academy_mark_complete: "Tandai selesai",
    academy_next: "Pelajaran berikutnya",
    academy_progress: "Progres",
    academy_lessons: "pelajaran",
    academy_completed_lessons: "Pelajaran selesai",
    academy_level: "Tingkat",
    academy_duration: "Durasi",
    academy_cert_title: "IPTECHS Certified Perfumer",
    academy_cert_body:
      "Belajar → Ujian Praktik → Penilaian Offline → Hasil → Sertifikasi. Kredensial profesional non-akademik yang diterbitkan oleh IPTECHS.",
    academy_cert_addon: "Sertifikasi adalah add-on berbayar terpisah. Tidak diterbitkan otomatis.",
    academy_membership_note:
      "Keanggotaan = akses PERSONA AI PERFUMER + akses IPTECHS Academy.",

    account_title: "Akun Saya",
    account_sub: "Kelola profil member dan akses Anda.",
    account_name: "Nama",
    account_email: "Email",
    account_language: "Bahasa preferensi",
    account_membership: "Status keanggotaan",
    account_ai_access: "Akses AI",
    account_academy_access: "Akses Academy",
    account_enabled: "Aktif",

    ai_direction_title: "AI Scent Direction",
    ai_direction_generate: "Buat AI Scent Direction",
    ai_direction_regenerate: "Buat ulang",
    ai_direction_from: "Interpretasi dari konsultasi saat ini",
    ai_pyramid_top: "Top Notes",
    ai_pyramid_heart: "Heart Notes",
    ai_pyramid_base: "Base Notes",
    ai_personality: "Fragrance Personality",
    ai_direction_line: "Olfactory Direction",
    ai_families_rec: "Rekomendasi Keluarga",
    ai_interpretation: "Interpretasi AI",
    ai_save_profile: "Simpan AI Fragrance Profile",
    ai_saved: "AI Fragrance Profile tersimpan",
    ai_not_official:
      "Interpretasi wewangian dihasilkan AI. Bukan hasil resmi PERSONA CORE.",
    saved_profiles_title: "AI Fragrance Profile Tersimpan",
    saved_profiles_empty: "Anda belum menyimpan AI fragrance profile.",

    sub_configuring: "Keanggotaan sedang dikonfigurasi. Harga dan checkout akan tersedia di sini.",
  },
  fr: {
    nav_journey: "Le Parcours",
    nav_founder: "Master Perfumer",
    nav_my_account: "Mon Compte",
    nav_academy: "IPTECHS Academy",

    landing_ecosystem_learn: "LEARN",
    landing_ecosystem_learn_desc: "IPTECHS Academy",
    landing_ecosystem_explore: "EXPLORE",
    landing_ecosystem_explore_desc: "PERSONA AI PERFUMER",
    landing_ecosystem_create: "CREATE",
    landing_ecosystem_create_desc: "PERSONA PERFUMERY TECH",
    heritage_eyebrow: "L'héritage derrière PERSONA",
    heritage_title: "Fondé par un maître parfumeur.",
    heritage_body:
      "PERSONA FRAGRANCE INTELLIGENCE est fondée par Tubagus Wijaya — maître parfumeur, technologue olfactif, et l'artisan de plus d'une décennie de recherche en parfumerie personnalisée.",
    heritage_cta: "RENCONTRER LE MAÎTRE PARFUMEUR",
    protected_eyebrow: "Technologie Protégée",
    protected_title: "Trois couches, un cœur protégé.",
    protected_persona: "PERSONA",
    protected_persona_desc: "Marque déposée",
    protected_software: "PERSONA SOFTWARE",
    protected_software_desc: "Droit d'auteur logiciel enregistré",
    protected_core: "PERSONA CORE",
    protected_core_desc: "Couche technologique propriétaire / confidentielle",
    twfh_eyebrow: "La Maison de Parfum",
    twfh_title: "TWFH",
    twfh_subtitle: "Tubagus Wijaya Fragrance House",
    twfh_position: "Maison de parfum · Artisanat · Formulation · Expertise olfactive",
    twfh_desc:
      "TWFH représente l'artisanat olfactif au cœur de l'écosystème — l'art parfumier, l'expertise en formulation et la création olfactive.",

    journey_eyebrow: "Maître Parfumeur",
    journey_name: "Tubagus Wijaya",
    journey_role: "Fondateur · Maître Parfumeur · Technologue olfactif",
    journey_statement:
      "De l'artisanat parfumier à la technologie olfactive personnalisée, ce parcours vise à rendre le parfum plus personnel, plus significatif et plus intelligent.",
    journey_timeline_title: "Le Parcours",
    j_2012_title: "Le Commencement",
    j_2012_body:
      "La recherche en parfumerie personnalisée commence — l'origine du concept devenu PERSONA.",
    j_2015_title: "Créativité & Innovation",
    j_2015_body: "Reconnaissance dans l'industrie créative et l'innovation des PME.",
    j_2016_title: "Entrepreneuriat",
    j_2016_body: "Reconnaissance entrepreneuriale à travers Parfum Gue.",
    j_16_18_title: "Éducation & développement professionnel en parfumerie",
    j_16_18_body:
      "Formation et développement professionnels en parfumerie à travers plusieurs expériences.",
    j_2019_title: "Innovation & Reconnaissance",
    j_2019_body:
      "Reconnaissance pour l'innovation produit et reconnaissance MURI pour un parfum personnalisé basé sur les traits de personnalité des clients.",
    j_2022_title: "Développement Entrepreneurial",
    j_2022_body: "6 Besar Talenta Wirausaha Berdaya — Bank Syariah Indonesia.",
    j_2026_title: "De la Technologie Parfumière à la Fragrance Intelligence",
    j_2026_body:
      "L'évolution de la vision en PERSONA FRAGRANCE INTELLIGENCE — reliant Expertise humaine + Savoir parfumier + IA conversationnelle + Technologie propriétaire.",
    edu_title: "Éducation & Développement Professionnel en Parfumerie",
    recog_title: "Innovation & Reconnaissance",
    legacy_title: "L'Héritage Technologique",
    legacy_intro:
      "Un écosystème cohérent — de l'artisanat à l'éducation, à l'intelligence olfactive conversationnelle et à la technologie propriétaire.",
    legacy_twfh_role: "Artisanat olfactif",
    legacy_iptechs_role: "Éducation olfactive",
    legacy_persona_role: "Technologie olfactive personnalisée",
    legacy_core_role: "Technologie propriétaire",
    legacy_ai_role: "Intelligence olfactive conversationnelle",
    legacy_platform_role: "L'écosystème qui relie",

    academy_eyebrow: "LEARN · Indonesia Perfumer Technology School",
    academy_title: "IPTECHS Academy",
    academy_intro:
      "Parcours d'apprentissage structurés, conçus et sélectionnés par le maître parfumeur — du vocabulaire aux systèmes olfactifs intelligents.",
    academy_courses: "Cours",
    academy_continue: "Reprendre",
    academy_start: "Commencer",
    academy_open: "Ouvrir",
    academy_locked: "Verrouillé",
    academy_completed: "Terminé",
    academy_mark_complete: "Marquer comme terminé",
    academy_next: "Leçon suivante",
    academy_progress: "Progression",
    academy_lessons: "leçons",
    academy_completed_lessons: "Leçons terminées",
    academy_level: "Niveau",
    academy_duration: "Durée",
    academy_cert_title: "IPTECHS Certified Perfumer",
    academy_cert_body:
      "Apprentissage → Examen pratique → Évaluation en présentiel → Résultat → Certification. Un titre professionnel non-académique délivré par IPTECHS.",
    academy_cert_addon: "La certification est une option payante distincte. Non délivrée automatiquement.",
    academy_membership_note:
      "Adhésion = accès PERSONA AI PERFUMER + accès IPTECHS Academy.",

    account_title: "Mon Compte",
    account_sub: "Gérez votre profil membre et vos accès.",
    account_name: "Nom",
    account_email: "E-mail",
    account_language: "Langue préférée",
    account_membership: "Statut d'adhésion",
    account_ai_access: "Accès IA",
    account_academy_access: "Accès Academy",
    account_enabled: "Activé",

    ai_direction_title: "AI Scent Direction",
    ai_direction_generate: "Générer une AI Scent Direction",
    ai_direction_regenerate: "Régénérer",
    ai_direction_from: "Interprétation de la consultation actuelle",
    ai_pyramid_top: "Notes de tête",
    ai_pyramid_heart: "Notes de cœur",
    ai_pyramid_base: "Notes de fond",
    ai_personality: "Personnalité olfactive",
    ai_direction_line: "Direction olfactive",
    ai_families_rec: "Familles recommandées",
    ai_interpretation: "Interprétation IA",
    ai_save_profile: "Enregistrer l'AI Fragrance Profile",
    ai_saved: "AI Fragrance Profile enregistré",
    ai_not_official:
      "Interprétation générée par l'IA. Ce n'est pas un résultat officiel PERSONA CORE.",
    saved_profiles_title: "AI Fragrance Profiles enregistrés",
    saved_profiles_empty: "Vous n'avez encore enregistré aucun AI fragrance profile.",

    sub_configuring: "L'adhésion est en cours de configuration. Les tarifs et le paiement apparaîtront ici bientôt.",
  },
};

// Merge helper used from translations.js
export default P2;
